import { render, staticRenderFns } from "./MyContactUs.vue?vue&type=template&id=a22badf2&scoped=true"
import script from "./MyContactUs.vue?vue&type=script&lang=js"
export * from "./MyContactUs.vue?vue&type=script&lang=js"
import style0 from "./MyContactUs.vue?vue&type=style&index=0&id=a22badf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22badf2",
  null
  
)

export default component.exports